export default __webpack_public_path__ + "static/media/reports_active.c8669fbd.svg";